interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const ArrowLIcon = (props: PropsType) => (
  <svg
    width="15"
    height="18"
    viewBox="0 0 15 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={props.style ? props.style : undefined}
  >
    <path d="M0 9L15 17.6603L15 0.339746L0 9Z" fill={props.color ? props.color : 'white'} />
  </svg>
);

export default ArrowLIcon;
